import { differenceInDays, differenceInWeeks, intervalToDuration, parseISO } from 'date-fns'

export interface Age {
  seconds: number
  minutes: number
  hours: number
  days: number
  months: number
  years: number
  ageInMonths: number
}

type DateInput = string | number

export function calculateAge(birthDate: DateInput, referenceDate: DateInput = Date.now()): Age {
  const endDate = referenceDate || Date.now()

  const interval = intervalToDuration({
    start: parseDate(birthDate),
    end: parseDate(endDate),
  })

  let { years, months, days } = interval
  const { hours, minutes, seconds } = interval

  if (days > 30) {
    months += Math.floor(days / 31)
    days = days % 31
  }
  if (months > 11) {
    years += Math.floor(months / 12)
    months = months % 12
  }

  const ageInMonths = 12 * years + months

  return { years, months, days, hours, minutes, seconds, ageInMonths }
}

export function calculateFractionalAgeInYears(birthDate: DateInput, referenceDate: DateInput = Date.now()): number {
  const startDate = parseDate(birthDate)
  const endDate = parseDate(referenceDate)

  return differenceInDays(endDate, startDate) / 365.2425
}

export function calculateAgeInWeeks(birthDate: DateInput, referenceDate: DateInput = Date.now()): number {
  const startDate = parseDate(birthDate)
  const endDate = parseDate(referenceDate)

  return differenceInWeeks(endDate, startDate)
}

function parseDate(date: DateInput): number | Date {
  if (isString(date)) {
    return parseISO(date)
  }

  return date
}

function isString(x: any): x is string {
  return typeof x === 'string'
}

export function monthsToYearsFloor(months: number): number {
  return Math.floor(months / 12)
}
